import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'hooks';
import { CustomInput } from 'reactstrap'
import { Topography, Button, Input, InputError, DropZone, InputLabel } from 'components/ui';
import DatePickerUI from 'components/ui/DatePicker/DatePicker';
import { Form, Field } from 'react-final-form';
import { Validators, Parsers, getSnapshotById, dataURLtoFile } from 'utils';
import moment from 'moment'
import SignatureCanvas from 'react-signature-canvas'
import { submitHippaForm, updateDocumentStatus, hippaFormReset } from 'store/actions/hippa.action'
import { hippaSelector } from 'store/reducers/hippa.reducer'
import { PreloaderWrapper } from 'components/containers';
import Alert from 'components/ui/Alert/Alert';
import feeIcons from 'assets/images/feeicons.png';
import learnIcons from 'assets/images/learnIcons.png';
import secureIcons from 'assets/images/secureIcons.png';
import simpleaccessIocns from 'assets/images/simpleaccessIocns.png';
import rectangleBg from 'assets/images/background.svg';
import logo from 'assets/images/logo.png';
import blue_lock from 'assets/images/blue_lock.png';
import green_key from 'assets/images/green_key.png';
import learn_more from 'assets/images/learn_more.png';
import dollar from 'assets/images/dollar.png';
import request_guidance from 'assets/images/request_guidance.gif';
import link_expire from 'assets/images/link_expire.gif';
import api2 from 'store/apis/api2';
import ExpiredLink from 'components/containers/ExpiredLink';
import { useHippaLinkValidation } from 'hooks/useHippaLinkValidation';

import { generateAuthPdf } from 'utils/pdfGenerator';
import { useTranslation } from 'react-i18next';

import './hippa.scss';

export const HIPPAAuthForm = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isSubmitting, error, success } = useSelector(hippaSelector)

  const { t } = useTranslation();

  const [requestId, setRequestId] = useState<string>('')
  const [orgName, setOrgName] = useState<string>('')
  const [orgNum, setOrgNum] = useState<string>('')
  const [groupId, setGroupId] = useState<string>('')
  const [authId, setAuthId] = useState<string>('')
  const [selectedFiles, setSelectedFiles] = useState<{ frontFile?: File, backFile?: File }>({})
  const [verifiedFiles, setVerifiedFiles] = useState<{ frontFile?: { fileName: string, fileURL: string }, backFile?: { fileName: string, fileURL: string } }>({})
  const [birthDay, setBirthDay] = useState<Date | undefined>();
  const [initialValues, setInitialValues] = useState<any>({});
  const [dispalyAuthInformation, setDispalyAuthInformation] = useState(true);
  const [isDrawMode, setDrawMode] = useState<boolean>(false)
  const [isSigned, setSigned] = useState<boolean>(false)
  const [isGovtIdRequired, setIsGovtIdRequired] = useState(false)
  const [verificationChecklist, setVerificationChecklist] = useState<any>({})

  const DOB_START_DATE = new Date(1990, 0, 1);
  const NAME_REGEX = /^[A-Za-z'-]*$/;
  const MAX_NAME_LENGTH = 50;

  const isGovtIdValid = !isGovtIdRequired || (Boolean(selectedFiles.frontFile || verifiedFiles.frontFile) && Boolean(selectedFiles.backFile || verifiedFiles.backFile))

  const { isCheckingLink, isLinkExpired } = useHippaLinkValidation();

  let signRef: any = useRef()

  useEffect(() => {

    const url_string = window.location.href;
    const url = new URL(url_string);
    const authDocumentId = url.searchParams.get('auth_document') || undefined;

    setIsGovtIdRequired(url.searchParams.get('government_id_required') === 'true')
    setRequestId(url.searchParams.get('request_id') || '')
    setOrgName(url.searchParams.get('org_name') || '')
    setOrgNum(url.searchParams.get('phone_number') || '')
    setGroupId(url.searchParams.get('group_id') || '')
    setAuthId(authDocumentId || '')

    if (url.searchParams.get('form') == 'true') {
      setDispalyAuthInformation(!dispalyAuthInformation)
      // if (process.env.NODE_ENV !== 'development') navigate('/')
    }

    return () => {
      dispatch(hippaFormReset())
    }
  }, [])

  useEffect(() => {
    if (!authId) return;

    let isMounted = true;

    const fetchAuthorizationDocument = async () => {
      try {
        const response = await api2.get(`/api/v2/provider_landing/get_auth_document?id=${authId}`)(dispatch, false, true);
        const responseData = response.data ?? response;
        if (!isMounted) return;

        const checklist = responseData?.verification_checklist || {};
        const signedDocuments = responseData?.signed_documents || {};

        console.log('HIPAA authorization prefill data:', {
          authDocumentId: authId,
          checklist,
          hasGovtIdFront: Boolean(signedDocuments.govt_id_front),
          hasGovtIdBack: Boolean(signedDocuments.govt_id_back),
        });

        setVerificationChecklist(checklist);

        setVerifiedFiles({
          frontFile: checklist.govt_front_verified && signedDocuments.govt_id_front ? {
            fileName: 'Govt ID Front',
            fileURL: signedDocuments.govt_id_front,
          } : undefined,
          backFile: checklist.govt_back_verified && signedDocuments.govt_id_back ? {
            fileName: 'Govt ID Back',
            fileURL: signedDocuments.govt_id_back,
          } : undefined,
        });
      } catch (err) {
        console.error('HIPAA authorization prefill error:', err);
      }
    };

    fetchAuthorizationDocument();

    return () => {
      isMounted = false;
    };
  }, [authId, dispatch])

  function handleChangeBirthDay(value: Date) {
    setBirthDay(value);
  }
  const handleFileUpload = (files: File[], key: string) => {
    setSelectedFiles(selectedFiles => ({ ...selectedFiles, [key]: files[0] }))
  }
  const handleFileRemove = (index: number, key: string) => {
    setSelectedFiles(selectedFiles => ({ ...selectedFiles, [key]: undefined }))
  }

  const renderVerifiedFile = (file: { fileName: string, fileURL: string }) => (
    <div
      className="w-100 auth_select_file hippa-dropzone mb-2"
      style={{
        height: '223px',
        maxWidth: '354.67px',
        border: '1px solid #c8c3c3',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0px 6px 15px 2px rgba(76, 107, 200, 0.08)',
      }}
    >
      <img src={file.fileURL} alt={file.fileName} style={{ width: '100%', height: '100%' }} />
    </div>
  )

  const createRequest = (values: any) => {
    if (isGovtIdRequired && (!(selectedFiles.frontFile || verifiedFiles.frontFile) || !(selectedFiles.backFile || verifiedFiles.backFile))) {
      return
    }

    const paragraphText = t('sub-heading-p-one') + t('sub-heading-p-two') + t('sub-heading-p-three') + t('text-bottom')

    if (isDrawMode) {
      const base64 = signRef.toDataURL('image/png')
      const file = dataURLtoFile(base64, 'image/png', 'signature.jpeg');
      const queryParams = new URLSearchParams(window.location.search);
      const authId = queryParams.get('auth_document');

      const fd = new FormData()
      fd.append('first_name', values.firstName)
      fd.append('middle_name', values.middleName || '')
      fd.append('last_name', values.lastName)
      fd.append('date_of_birth', values.birthDay)
      fd.append('ssn', values.ssn || '')
      fd.append('sign_name', values.signature)
      fd.append('request_id', requestId)
      fd.append('group_id', groupId)
      fd.append('signature', file)
      fd.append('id', authId || '');
      if (selectedFiles.frontFile) fd.append('govt_id_front', selectedFiles.frontFile)
      if (selectedFiles.backFile) fd.append('govt_id_back', selectedFiles.backFile)

      const pdfData = {
        lang: '',
        submittedOn: moment().format('MM/DD/YYYY'),
        address: [orgName],
        subTitle: t('Sub-heading-one'),
        paragraph1: paragraphText,
        signature: {
          label: t('text-Signature'),
          signature: file,
        },
        patientName: {
          label: 'Patient Name',
          patient: `${values.firstName} ${values.middleName || ''} ${values.lastName}`,
        },
        formInput: [
          { label: t('text-ssn-label'), value: values.ssn || '' },
          { label: t('text-name-label'), value: `${values.firstName} ${values.middleName || ''} ${values.lastName}` },
          { label: t('text-date-label'), value: values.birthDay },
        ],
      };

      generateAuthPdf(pdfData, ({ blobPDF }: { blobPDF: Blob }) => {
        fd.append('signed_authorization', blobPDF, 'hipaa_authorization.pdf');

        dispatch(submitHippaForm(fd, () => {
          setInitialValues({})
          setBirthDay(undefined)
          setSelectedFiles({})
        }))
      })
      setInitialValues(values)
    } else {
      getSnapshotById('#signature', async (signatureFile: File) => {
        const normalizedSignature =
          signatureFile.type === 'image/jpeg'
            ? new File([signatureFile], 'signature.png', { type: 'image/png' })
            : signatureFile;

        const fd = new FormData();
        const queryParams = new URLSearchParams(window.location.search);
        const authId = queryParams.get('auth_document');

        fd.append('first_name', values.firstName);
        fd.append('middle_name', values.middleName || '');
        fd.append('last_name', values.lastName);
        fd.append('date_of_birth', values.birthDay);
        fd.append('ssn', values.ssn || '');
        fd.append('sign_name', values.signature); // text
        fd.append('request_id', requestId);
        fd.append('group_id', groupId);
        fd.append('signature', normalizedSignature);
        fd.append('id', authId || '');

        if (selectedFiles.frontFile) fd.append('govt_id_front', selectedFiles.frontFile);
        if (selectedFiles.backFile) fd.append('govt_id_back', selectedFiles.backFile);

        const pdfData = {
          lang: '',
          submittedOn: moment().format('MM/DD/YYYY'),
          address: [orgName],
          subTitle: t('Sub-heading-one'),
          paragraph1: paragraphText,
          signature: {
            label: t('text-Signature'),
            signature: normalizedSignature,
          },
          patientName: {
            label: 'Patient Name',
            patient: `${values.firstName} ${values.middleName || ''} ${values.lastName}`,
          },
          formInput: [
            { label: t('text-ssn-label'), value: values.ssn || '' },
            { label: t('text-name-label'), value: `${values.firstName} ${values.middleName || ''} ${values.lastName}` },
            { label: t('text-date-label'), value: values.birthDay },
            { label: t('text-initials-label'), value: values.signature },
          ],
        };

        generateAuthPdf(pdfData, ({ blobPDF }: { blobPDF: Blob }) => {
          fd.append('signed_authorization', blobPDF, 'hipaa_authorization.pdf');

          dispatch(submitHippaForm(fd, () => {
            setInitialValues({});
            setBirthDay(undefined);
            setSelectedFiles({});
          }));
        });

        setInitialValues(values);
      });

    }
  }
  // const onBegin = () => authId && dispatch(updateDocumentStatus(authId))

  if (isCheckingLink) return <PreloaderWrapper />
  else if (isLinkExpired) return <ExpiredLink />;

  if (isSubmitting) return <PreloaderWrapper />
  else if (success) return (
    <div className='hipaa-wrapper success-page-wrapper' >
      <div className='hipaa-card success-card'>
        <div className="success-iconWrapper">
          <img src={request_guidance} alt="View" width={140} height={140} />
        </div>

        <h1 className='success-title'>
          HIPAA Authorization Signed Successfully!
        </h1>

        <p className='success-subtitle'>
          We've sent an email to {orgName} notifying them that you've submitted your authorization.
        </p>

        <button className="submit-btn">
          <a href={`${process.env.REACT_APP_BASE_API_URL}/patient`} className='text-white' target="_blank" rel="noopener noreferrer">Explore ChartRequest</a>
        </button>
      </div>
    </div>
  )

  return (
    <div className='hippa_info_wrapper d-flex flex-column'>
      {dispalyAuthInformation ? (
        <div>
          <div className="col-12 col-md-10 col-lg-8 mx-auto mob_padding_0 my-4">
            <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">

              {/* Title */}
              <Topography.H4 className="hippa-section-title mb-4">
                Request Your Medical Records
              </Topography.H4>

              {/* Secure */}
              <div className="hippa-info-item">
                <div className="icon-pill">
                  <img src={blue_lock} />
                </div>

                <div>
                  <Topography.H4 className="hippa-info-title mb-1">
                    Secure, Encrypted Account
                  </Topography.H4>
                  <p className="hippa-info-text mb-0 text-muted">
                    Upon completion of the following online request form, your medical
                    records required by <strong>{orgName}</strong> will be transferred to
                    your law firm and into a secure account maintained by ChartRequest, a health information exchange.
                  </p>
                </div>
              </div>


              {/* Simple Access */}

              <div className="hippa-info-item">
                <div className="icon-pill">
                  <img src={green_key} />
                </div>

                <div>
                  <Topography.H4 className="hippa-info-title mb-1">
                    Simple Access
                  </Topography.H4>
                  <p className="hippa-info-text mb-0 text-muted">
                    Once transferred, your record will be maintained within your ChartRequest account for you to access, view, download, or share with a healthcare professional.
                  </p>
                </div>
              </div>

              {/* Fees */}

              <div className="hippa-info-item">
                <div className="icon-pill bg-primary">
                  <img src={dollar} />
                </div>

                <div>
                  <Topography.H4 className="hippa-info-title mb-1">
                    Fees
                  </Topography.H4>
                  <p className="hippa-info-text mb-0 text-muted">
                    A transfer fee will be charged for this request if you want to store your records with ChartRequest.
                  </p>
                </div>
              </div>

              {/* Learn More */}

              <div className="hippa-info-item">
                <div className="icon-pill bg-primary">
                  <img src={learn_more} />
                </div>

                <div>
                  <Topography.H4 className="hippa-info-title mb-1">
                    Learn More
                  </Topography.H4>
                  <p className='hippa-info-text mb-0 text-muted'>Visit <a href='https://www.chartrequest.com/patient-solutions/store-share' target='_blank' style={{ color: '#4062E5' }}>chartrequest.com</a> to learn more about ChartRequest and the functionality of the online account where your medical records will be stored if you would like to access.</p>
                </div>
              </div>


              {/* CTA */}
              <a href={window.location.href + '&form=true'} target="_blank">
                <button
                  className="btn btn-primary btn-lg w-100"
                  // onClick={onBegin}
                  style={{ fontSize: '16px' }}
                >
                  Begin
                </button>
              </a>

            </div>
          </div>
        </div>
      ) : (
        <div>
          {/* ===== HIPAA AUTHORIZATION HEADER ===== */}
          <div className="bg-white col-12 col-md-10 col-lg-8 mx-auto mb-4">

          </div>

          {/* ===== MAIN CARD ===== */}
          <div className="col-12 col-md-10 col-lg-8 mx-auto mb-5">
            <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">

              <Topography.H4 className="mb-2">
                HIPAA Authorization
              </Topography.H4>

              <p className="text-muted" style={{ fontSize: "12px" }}>
                Please complete this HIPAA authorization form requested by ({orgName}).
                Please call ({orgNum}) if you have questions about this form.
              </p>

              <br></br>

              {error && <Alert type="error">{error}</Alert>}
              {success && <Alert type="success">{success}</Alert>}

              <div className='form-page'>
                {/* ===== FORM TITLE ===== */}
                <div className="text-center fw-bold text-dark mb-4" style={{ fontWeight: "bold" }}>
                  INDIVIDUAL ELECTRONIC RECORD RELEASE AUTHORIZATION FORM
                </div>

                {/* ===== FORM DESCRIPTION ===== */}
                <p className="text-muted small" style={{fontSize: '14px'}}>
                  I, the undersigned, authorize the Custodian (the "Provider" and/or "ChartRequest") to disclose or obtain my protected health information as directed. I understand that this disclosure of protected health information may include sensitive information such as alcohol and or drug abuse, child abuse/neglect, sexual assault/abuse, domestic abuse, sexually transmitted diseases, termination of pregnancy, sexual preference, history of behavioral health, mental health counseling or family problems. Any information not to be released must be specified. I understand that the information, used, disclosed, released or obtained as a result of this authorization may be further used, disclosed or released by any recipient of this information and therefore is no longer protected by relevant privacy laws. I acknowledge that I am electronically authorizing the Provider and/or ChartRequest by electronically signing this form. Please note, the Provider may not condition my treatment on whether I sign this authorization. By electronically signing this form, you authorize the Provider and/or ChartRequest to disclose protected health information concerning the identified patient, which must be you. I understand that I may revoke this authorization at any time. Any revocation by you will not affect any uses or disclosures permitted by your authorization while it was in effect.<br /><br />
                  Further, I want all of my records released including those instances including and not limited to: HIV and/or AIDS testing Genetic Testing, Alcohol and/or Drug Abuse, Mental Health Counseling, Psychiatric Treatment, Domestic Violence/Abuse, Child Abuse/Neglect, Sexual Assault/Abuse, Sexually Transmitted Diseases.<br /><br />
                  I understand records released may contain Alcohol and Drug Abuse Records Protected by Federal Confidentiality Rules 42 CFR Part 2. FEDERAL RULES PROHIBIT ANY FURTHER DISCLOSURE OF THIS INFORMATION UNLESS DISCLOSURE IS EXPRESSLY PERMITTED BY WRITTEN AUTHORIZATION OF THE PERSON TO WHOM IT PERTAINS, OR AS OTHERWISE PERMITTED BY 42 CFR PART 2.<br /><br />
                  I understand that I am requesting all available records. By selecting Adopt and Sign, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.
                </p>

                {/* ===== FORM CONTAINER ===== */}
                <div className="rounded-3 p-4 mt-4" style={{ backgroundColor: '#F5F7FE' }}>

                  <Form
                    initialValues={initialValues}
                    onSubmit={createRequest}
                    render={({ handleSubmit, hasValidationErrors, values }) => (
                      <form className="row g-3 auth_sign_form" onSubmit={handleSubmit}>

                        {/* ===== NAME FIELDS ===== */}
                        <Field name="firstName" validate={Validators.required}>
                          {({ input, meta }) => (
                            <div className="col-md-4">
                              <InputLabel text="First Name *" className="form-label" />
                              <Input
                                {...input}
                                type="text"
                                maxLength={MAX_NAME_LENGTH}
                                className="hippa-input"
                                placeholder="Required"
                                hasError={meta.submitFailed && meta.error}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (NAME_REGEX.test(value)) {
                                    input.onChange(value);
                                  }
                                }}
                              />
                            </div>
                          )}
                        </Field>


                        <Field name="middleName">
                          {({ input }) => (
                            <div className="col-md-4">
                              <InputLabel text="Middle Name" className='form-label' />
                              <Input {...input} type="text" className="hippa-input" onChange={(e) => {
                                const value = e.target.value;
                                if (NAME_REGEX.test(value)) {
                                  input.onChange(value);
                                }
                              }} />
                            </div>
                          )}
                        </Field>

                        <Field name="lastName" validate={Validators.required}>
                          {({ input, meta }) => (
                            <div className="col-md-4">
                              <InputLabel text="Last Name *" className="form-label" />
                              <Input
                                {...input}
                                type="text"
                                maxLength={MAX_NAME_LENGTH}
                                className="hippa-input"
                                placeholder="Required"
                                hasError={meta.submitFailed && meta.error}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (NAME_REGEX.test(value)) {
                                    input.onChange(value);
                                  }
                                }}
                              />
                            </div>
                          )}
                        </Field>


                        {/* ===== DOB & SSN ===== */}

                        <Field
                          name="birthDay"
                          validate={Validators.compose(Validators.required, Validators.pastDate)}
                          render={({ input, meta }) => {
                            input.onChange(birthDay && moment(birthDay).format(process.env.REACT_APP_DATE_FORMAT));
                            return (<div className='col-12 col-md-4 mb-3 mt-3'>
                              <InputLabel text='Date of Birth *' className='form-label' />
                              <div className="hippa-datepicker">
                                <DatePickerUI onChange={handleChangeBirthDay} withLabel={true} value={birthDay} openToDate={DOB_START_DATE} futureDateNotAllowed={true}>
                                  {meta.error && birthDay && <InputError>{meta.error}</InputError>}
                                </DatePickerUI>

                              </div>

                            </div>);
                          }}
                        />

                        <Field name="ssn" validate={Validators.validSnn} parse={Parsers.ssn}>
                          {({ input, meta }) => (
                            <div className="col-md-4 mt-3">
                              <InputLabel text="Social Security Number" className='form-label' />
                              <Input {...input} type="text" hasError={meta.error && meta.touched} className="hippa-input" placeholder='Optional' />
                              {meta.error && meta.touched && <InputError>{meta.error}</InputError>}
                            </div>
                          )}
                        </Field>

                        {/* ===== GOVT ID ===== */}
                        <div className="col-12 mt-3">
                          <InputLabel text={`Govt. ID (${isGovtIdRequired ? 'Required' : 'Optional'})`} className="form-label" />
                          <p className="text-muted small mb-3" style={{fontSize: '14px'}}>
                            Please upload a valid Govt. ID. Ex. Driver's License, Passport, etc.
                            Why do we ask for this information? We are gathering sensitive information
                            on your behalf and proof of identity keeps this process secure.
                          </p>

                          <div className="row gy-3">
                            <Field name="frontFile">
                              {({ input }) => (
                                <div className="col-12 col-md-5">
                                  <InputLabel text="Front" className='form-label' />
                                  {verificationChecklist.govt_front_verified && verifiedFiles.frontFile ? (
                                    renderVerifiedFile(verifiedFiles.frontFile)
                                  ) : (
                                    <DropZone
                                      className="w-100 auth_select_file hippa-dropzone"
                                      selectedFiles={selectedFiles.frontFile ? [selectedFiles.frontFile] : []}
                                      onUpload={e => handleFileUpload(e, input.name)}
                                      onRemove={e => handleFileRemove(e, input.name)}
                                      maxFileCount={1}
                                      placeholder="Drop your file here or "
                                      placeholder2="Supports JPG, PNG documents"
                                      accept="image/*"
                                    />
                                  )}
                                </div>
                              )}
                            </Field>

                            <Field name="backFile">
                              {({ input }) => (
                                <div className="col-12 col-md-5">
                                  <InputLabel text="Back" className='form-label' />
                                  {verificationChecklist.govt_back_verified && verifiedFiles.backFile ? (
                                    renderVerifiedFile(verifiedFiles.backFile)
                                  ) : (
                                    <DropZone
                                      className="w-100 auth_select_file hippa-dropzone"
                                      selectedFiles={selectedFiles.backFile ? [selectedFiles.backFile] : []}
                                      onUpload={e => handleFileUpload(e, input.name)}
                                      onRemove={e => handleFileRemove(e, input.name)}
                                      maxFileCount={1}
                                      placeholder="Drop your file here or "
                                      placeholder2="Supports JPG, PNG documents"
                                      accept="image/*"
                                    />
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                        </div>

                        {/* ===== SIGNATURE TYPE ===== */}

                        <div className='col-12 my-3 d-flex align-items-center'>
                          <InputLabel text='Type' htmlFor='signatureSwitch' className='form-label' />
                          <CustomInput type="switch" id="signatureSwitch" name="signatureSwitch" className='ml-2 mb-1' onChange={e => { setDrawMode(e.target.checked); setSigned(false) }} />
                          <InputLabel text='Draw' htmlFor='signatureSwitch' className='form-label' />
                        </div>

                        {isDrawMode ? (
                          <div className='col-12 col-md-4 my-3'>
                            <InputLabel text='Signature (Full Name)' className='form-label' />
                            <div className='previewContainer'>
                              <SignatureCanvas penColor='black' canvasProps={{ className: 'signCanvas' }} ref={i => signRef = i} />
                            </div>
                            <div className='text-right mt-2'>
                              <span role='button' className='file-name' onClick={() => {
                                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                signRef?.clear(); setSigned(false)
                              }}>Clear</span>
                            </div>
                          </div>
                        ) : (<>

                          <Field name="signature" validate={Validators.required}>
                            {({ input, meta }) => (
                              <div className="col-12 col-md-4 mb-3">
                                <InputLabel text="Signature (Full Name)" className="form-label" />
                                <Input
                                  {...input}
                                  type="text"
                                  placeholder="Required"
                                  className="hippa-input"
                                  hasError={meta.submitFailed && meta.error}
                                />
                              </div>
                            )}
                          </Field>
                          <div className='col-md-8'></div>
                          <div className='col-12 mb-3'>
                            <InputLabel text='Preview' className='form-label' />
                            <div className='previewContainer w-100 bg-white'>
                              <div className='row w-100'>
                                <div className='col-10 d-flex ml-5'>
                                  <div className='signatureContainer'></div>
                                  <div>
                                    <div className='head'>Signed by:</div>
                                    <div className='signature p-3' id='signature'>{values.signature}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>)}

                        <div className="col-12 mt-5" style={{ opacity: hasValidationErrors || (isDrawMode && !isSigned) || !isGovtIdValid ? 0.5 : 1, }}>
                          <Button
                            htmlType="submit"
                            className="w-100 btn-primary py-3"
                            disabled={hasValidationErrors || (isDrawMode && !isSigned && !isGovtIdValid)}
                          >
                            ADOPT & SIGN
                          </Button>
                        </div>

                      </form>
                    )}
                  />
                </div>

              </div>



            </div>
          </div>
        </div>
      )}

    </div>
  )
}
